import i18n from '@/i18n/index';
import availableLocales from '@/i18n/available_locales';
import { storeLocale } from '@/i18n/utils';

export default function (store) {
  store.subscribe((mutation) => {
    let newLocale;

    if (mutation.type === 'setLocale') {
      newLocale = mutation.payload;

      i18n.locale = newLocale;
      i18n.fallbackLocale = availableLocales[newLocale].fallbackLocale || 'en';

      storeLocale(newLocale);
    }
  });
}



// WEBPACK FOOTER //
// ./src/store/plugins/i18n.js